export const MAX_FIRST_CELL_WIDTH = 300;
export const TOTAL_NUM_OF_COLUMNS = 9;

export const MAX_TOPIC_NAME_LENGTH = 100;
export const DIALOG_BODY_PADDING = 3;

const GRID_ROW_WIDTH = 12;
export const DEFAULT_LABEL_WIDTH = 3;
export const DEFAULT_FIELD_WIDTH = GRID_ROW_WIDTH - DEFAULT_LABEL_WIDTH;

export const TOPIC_COLUMNS_NUM = 9;

export const MAX_CHIPS_IN_LIST = 5;

export const SNACKBAR_TIME_MS = 6000;

export const SEARCH_HINT_TEXT = "Search topic group or topic";